import {NOTIFICATIONS_LENGTH} from 'common/constants';
import {DialogTypes} from 'common/names';
import {layoutActions} from 'features/layout/redux';
import {truncate} from 'lodash';
import React from 'react';
import {ToastProps} from 'react-toast-notifications';
import {IToast} from '../redux/types';

interface NotificationsProps {
   toasts: IToast[];
   onClose: any;
   toastManager: any;
   openSubDialog: typeof layoutActions.openSubDialog;
}
class Notifications extends React.Component<ToastProps & NotificationsProps> {
   componentDidUpdate() {
      const {toasts, onClose, toastManager} = this.props;
      toasts.forEach((toast) => {
         const {...t} = toast;

         toastManager.add(
            <div onClick={() => this.openDialog(t.message)}>
               {truncate(t.message, {
                  length: NOTIFICATIONS_LENGTH,
               })}
            </div>,
            {
               appearance: t.level,
               autoDismiss: true,
               autoDismissTimeout: 3000,
               ...t,
            },
            () => onClose(t.id)
         );
      });
   }

   openDialog = (msg: string) => {
      if (msg.length > NOTIFICATIONS_LENGTH) {
         this.props.openSubDialog({id: DialogTypes.AlertDialog.id, content: msg});
      }
   };

   render() {
      return null;
   }
}

export default Notifications;
